import { useContext } from 'react'
import { useParams } from 'react-router'
import { useFetching } from '../hooks/useFetching'
import { AuthContext } from '../context'
import Button from '../components/ui/Button'
import ResultService from '../api/ResultService'
import { useNavigate } from 'react-router-dom'
import Input from '../components/ui/Input'

const Question = ({ questions, disciplineAndTeacher }) => {
  const { studentId, employeeId } = useContext(AuthContext) 

  const params = useParams()
  const qNumber = params.number
  const qId = questions.find(q => q.number == qNumber).id

  const getQuestionTextById = (qId) => {
    return questions.find(q => q.id == qId)?.text
  }

  const redirect = useNavigate()

  const saveAnswers = () => {
    const results = []
    let emptyCount = 0

    const discTeacherElem = document.querySelectorAll(".question__table tbody tr")
    for (let i = 0; i < discTeacherElem.length; i++) {
      let result = {
        id: 0,
        studentId: studentId,
        teacherId: parseInt(discTeacherElem[i].dataset.teacherid),
        disciplineId: parseInt(discTeacherElem[i].dataset.disciplineid),
        questionId: qId,
        moderatorId: employeeId    
      }

      const answerChecked = discTeacherElem[i].querySelector("input[type=radio]:checked")
      if (answerChecked) {
        result.answerId = parseInt(answerChecked.closest("label").dataset.answerid)
      } else {
        result.answerId = null
      }

      const answerComment = discTeacherElem[i].querySelector("input[type=text]")
      if (answerComment) {
        if (answerComment.value.trim().length > 0) {
          result.commentToAnswer = answerComment.value.trim()
        } else {
          result.commentToAnswer = null
        }
      } else {
        result.commentToAnswer = null
      }

      if (result.answerId == null && result.commentToAnswer == null) {
        discTeacherElem[i].classList.add("empty")
        emptyCount++
      } else {
        discTeacherElem[i].classList.remove("empty")
      }
      
      results.push(result)
    }
    
    if (emptyCount > 0) {
      alert("Вы не везде поставили оценку или комментарии")
    } else {
      createResults(results)
    }
  }

  const [createResults, isResultsLoading, resultsErr] = useFetching(async (results) => {
    const response = await ResultService.createResults(results)
    redirect(`/student/question/${parseInt(qNumber) + 1}`, {
      state: { questions: questions, disciplineAndTeacher: disciplineAndTeacher }
    })
  })

  const generateKey = prefix => `${prefix}-${new Date().getTime()}`;

  return (
    <div className='question'>
        <div className="container">
            <h2 className="question__title title">
                {
                  qNumber + ". " + getQuestionTextById(qId)
                }
            </h2>
            <div className="question__table">
                    {
                      <table>
                        <thead>
                          <tr>
                            <th>Дисциплина и преподаватель</th>
                            <th>Варианты ответа</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                          disciplineAndTeacher.map(item => {
                            return (
                              <tr key={item.id} data-teacherid={item.teachers.id} data-disciplineid={item.id}>
                                <td>{`${item.name} (${item.teachers.fio})` }</td>
                                <td>
                                    {
                                      questions.find(q => q.id == qId).listAnswer.map((qEl, idx) => {
                                        return (
                                            qEl.text
                                            ?
                                              <label key={qEl.id} data-answerid={qEl.id}>
                                                {qEl.text}
                                                <Input type="radio" name={`radio${item.id}`} id={`radio${item.id * (idx + 1)}`} />
                                              </label>
                                            :
                                            <Input key={generateKey("text")} type="text" placeholder="Комментарии" id={`input${item.id}`} />
                                        )
                                      })
                                    }
                                </td>
                              </tr>
                            )
                          })
                        }
                        </tbody>
                      </table>
                    }
                
            </div>
            <Button type="button" onClick={() => saveAnswers()} disabled={isResultsLoading} className={`question__next-btn btn${isResultsLoading ? " disable" : ""}`}>
              {isResultsLoading ? "Отправка данных..." : "Далее"}
            </Button>
        </div>
    </div>
  )
}

export default Question